import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { useToast } from '../lib/toast';
import { Modal } from './Modal';

export default function LogoutButton() {
  const { logout } = useAuth();
  const { push } = useToast();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  async function confirm() {
    setBusy(true);
    try {
      await logout();
      push('success', 'Logged out');
      nav('/login', { replace: true });
    } catch {
      push('error', 'Could not log out');
    } finally {
      setBusy(false);
      setOpen(false);
    }
  }

  return (
    <>
      <button
        className="w-full rounded-xl px-4 py-3 font-semibold
                   border border-red-300 dark:border-red-900
                   text-red-600 dark:text-red-400
                   hover:bg-red-50 dark:hover:bg-red-950/40"
        onClick={() => setOpen(true)}
      >
        Log out
      </button>

      <Modal open={open} onClose={() => !busy && setOpen(false)}>
        <h3 className="text-xl font-bold">Log out?</h3>
        <p className="mt-2 text-sm text-neutral-600 dark:text-neutral-300">
          You will need to sign in again to access your account.
        </p>
        <div className="mt-5 grid grid-cols-2 gap-2">
          <button
            className="btn-ghost"
            onClick={() => setOpen(false)}
            disabled={busy}
          >
            Stay signed in
          </button>
          <button
            className="rounded-xl px-4 py-2.5 font-semibold bg-red-600 text-white hover:bg-red-700 disabled:opacity-60"
            onClick={confirm}
            disabled={busy}
          >
            {busy ? 'Logging out…' : 'Yes, log out'}
          </button>
        </div>
      </Modal>
    </>
  );
}
